/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const PAGE_ALIASES = {
    product: 'pdp',
    subscriptionsExp: 'pdp',
    pla: 'plp',
    search: 'plp',
    cart: 'cart',
    payment: 'checkout',
    'payment-floral': 'checkout',
    recipient: 'checkout',
    enrollment_lander: 'enrollment_lander',
};

const isPassportEnrollmentActive = (featureFlags = {}, page) => {
    const config = featureFlags['is-celebrations-passport-enrollment-active-ft'];
    if (typeof config === 'boolean') return config;
    const pageConfig = config?.[PAGE_ALIASES[page] || page];
    if (typeof pageConfig === 'boolean') return pageConfig;
    return pageConfig?.atc_module === true || pageConfig?.product_card_logo === true;
};

export default isPassportEnrollmentActive;
